import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
import Toasted  from 'vue-toasted';
Vue.use(Toasted)

Vue.prototype.$eventBus = new Vue()

Vue.use(Vuesax);

import DisableAutocomplete from '@aacassandra/vue-disable-autocomplete';

Vue.use(DisableAutocomplete);

// axios
import axios from "./axios.js"

Vue.prototype.$axios = axios;
// Crm request
import business from "./request/business-request.js"
Vue.prototype.$business = business;

// Oauth request
import oauth from './request/auth-request.js';
Vue.prototype.$oauth = oauth;

// Processor request
import processor from './request/processor-request.js';
Vue.prototype.$processor = processor;

// Report request
import report from './request/report-request.js';
Vue.prototype.$report = report;

// Task request
import task from './request/task-request.js';
Vue.prototype.$task = task;

// Task request 5001
import task5001 from './request/task5001-request';
Vue.prototype.$task5001 = task5001;

// Task request 5002
import task5002 from './request/task5002-request';
Vue.prototype.$task5002 = task5002;

// Spread request
import spread from './request/spread-request.js';
Vue.prototype.$spread = spread;

// API Calls
import "./http/requests"

// mock
import "./fake-db/index.js"

// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'

Vue.use(VueHammer);

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css');

import firebase from "firebase/app";
import "firebase/messaging";

if (firebase.messaging && firebase.messaging.isSupported()) {
  var config = {
    apiKey: "AIzaSyDOZ_Ymbf-DEEC7r3TxPK7XeYUv9B3BOhA",
    authDomain: "intface.firebaseapp.com",
    databaseURL: "https://intface.firebaseio.com",
    projectId: "intface",
    storageBucket: "intface.appspot.com",
    messagingSenderId: "1016522620600",
    appId: "1:1016522620600:web:d535f70e0dfbf62b5bfe4d",
    measurementId: "G-X2333RYQ7M"
  };
  firebase.initializeApp(config);

  Vue.prototype.$messaging = firebase.messaging()

  navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    Vue.prototype.$messaging.useServiceWorker(registration)
  }).catch(err => {
  })
}


// VeeValidate
import VeeValidate from 'vee-validate';
import messagesVn from './i18n/messages/vn.js';
import attributesVn from './i18n/attributes/vn.js';
// import attributesVn from './i18n/attributes/i18nData.js';
import i18n from './i18n/i18n'
import moment from 'moment';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});

const phoneRule = {
  validate(value) {
    const mobilePhoneRule = /(0[3|5|7|8|9])+([0-9]{8})\b/;
    return mobilePhoneRule.test(value);
  }
};

VeeValidate.Validator.extend('phone_rule', phoneRule);
// import VueFbCustomerChat from 'vue-fb-customer-chat'

// Vue.use(VueFbCustomerChat, {
//   page_id: 104762274749651, //  change 'null' to your Facebook Page ID,
//   theme_color: '#333333', // theme color in HEX
//   locale: 'en_US', // default 'en_US'
// })
Vue.use(VeeValidate, {
  locale: 'vn',
  dictionary: {
    vn: {
      messages: messagesVn,
      attributes: attributesVn
    },
  }
});

const DEFAULT_TITLE = 'Crawl Data System';
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = DEFAULT_TITLE;
  });
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app');
